import { IListItem } from "../types";

export function getFullName(item: IListItem): string {
    let name = "";
    if (item && item?.first_name) {
        name += `${item?.first_name.trim()} `;
    }
    if (item && item?.last_name) {
        name += item?.last_name.trim();
    }
    return name.toLowerCase();
}

export function capitaliseFullName(customer: IListItem) {
    const fullName = getFullName(customer)
    if (fullName.length === 0) {
        return null;
    }

    const splitName = fullName.split(' ');

    const capitalisedName = splitName.map((name: string) =>
        name.split('-').map(n => {
            const s = n.split('');
            if (Array.isArray(s) &&
                s.length > 0 &&
                typeof s[0] === "string") {
                s[0] = s[0].toUpperCase();
            }

            return s.join('');
        }).join('-')
    ).join(' ')

    return capitalisedName;
}

export function getUniqueCustomers(customersList: IListItem[]): string[] {
    const newSet = new Set<string>();
    for (const item of customersList) {
        const name = capitaliseFullName(item)
        if (name) {
            newSet.add(name);
        }
    }
    return Array.from(newSet);
}
